import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-theme-header',
  templateUrl: './theme-header.component.html',
  styleUrls: ['./theme-header.component.scss']
})
export class ThemeHeaderComponent {

  /**
   * Makes the "EST 2026" label an interactive trigger. Only /payment-or-promo sets this —
   * there it replaces the star-icon PIN button. Everywhere else the label is inert text,
   * which matches the default theme where that button is already disabled or absent.
   */
  @Input() estClickable = false;

  @Output() estClick = new EventEmitter<void>();

  onEstClick() {
    if (this.estClickable) {
      this.estClick.emit();
    }
  }

}
